import { Component, OnInit, Input } from "@angular/core";
import { UtilityServiceService } from "app/services/utility-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CarrierService } from "app/services/carrier.service";

import { ToastrService } from "ngx-toastr";
import { PopupService } from "app/services/shared/popup.service";
import { PermitService } from "app/services/permit.service";
import { AuthWebService } from "app/services/authweb.service";
import { ApplicationService } from "app/services/application.service";
import { environment } from "../../../../src/environments/environment";
import { accounting } from "accounting";
import { ReturnStatement } from "@angular/compiler";
import { Location } from "@angular/common";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "../toast-notification/toast-notification.service";

//import { PrintingComponent } from 'app/approval-manager/printing/printing.component';

@Component({
  selector: "footer-btn",
  templateUrl: "./footer-btn.component.html",
  styleUrls: ["./footer-btn.component.css"],
})
export class FooterBtnComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  message: string = "Processing approval. Please wait...";
  isLoading: boolean = false;
  showMenuBtn: boolean = false;
  username = "iCBMS System";
  permitStatus1: any = 0;
  permitStatus2: any = 0;
  carrierStatus1: any = 0;
  carrierStatus2: any = 0;

  permitStatus6: number;
  permitStatus4: number;
  permitStatus7: number;
  permitStatus10: number;
  permitStatus13: number;
  permitStatus14: number;
  type: any;
  toastr: any;
  permitMFA: any;
  aUser: any;
  details_Id;
  constructor(
    private applicationService: ApplicationService,
    private toastService: ToastNotificationService,
    private location: Location,
    public utility: UtilityServiceService,
    private router: Router,
    private carrierService: CarrierService,
    private notice: ToastrService,
    private msgService: PopupService,
    private permitService: PermitService,
    private authWebService: AuthWebService,
    private toaster: ToastrService,
    private confirmDialogService: ConfirmDialogService,
    private route: ActivatedRoute
  ) {
    this.type = this.utility.permitType;
    console.log(this.utility, "PermitType@@@@@@@@@@@@@@");
  }

  ngOnInit() {
    this.details_Id = this.route.snapshot.paramMap.get("id");
    console.log(this.details_Id, "FOoter");
    this.utility.initTooltip();
    this.username = this.authWebService.userInfo().username;
    this.aUser = environment.authWebApi.userData.User;
    if (
      environment.authWebApi.systemData != null &&
      environment.authWebApi.systemData.Configurations != null
    ) {
      this.permitStatus1 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus1"
        ).Value;
      this.permitStatus2 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus2"
        ).Value;

      this.permitStatus4 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus4"
        ).Value;
      this.permitStatus6 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus6"
        ).Value;
      this.permitStatus7 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus7"
        ).Value;
      this.permitStatus10 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus10"
        ).Value;
      this.permitStatus13 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus13"
        ).Value;
      this.permitStatus14 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "PermitStatus14"
        ).Value;

      this.carrierStatus1 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "AccountStatus1"
        ).Value;
      this.carrierStatus2 =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "AccountStatus2"
        ).Value;

      this.permitMFA = environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "PermitMFA"
      ).Value;
    }

    this.getUpdateBalance();
  }

  changeView = (activeC: number, action = 0, actionStatus: number) => {
    if (this.canActivate(action)) {
      // action = 0 (Cancel)
      // action = 1 (Additional Info)
      // action = 2 (Approve)
      // action = 5 (Change Status)
      if (action == 2) {
        // 2
        this.onApproveCarrier();
      } else {
        // 0 + 1 + 5
        this.utility.currentActive = this.ctrlData.currentActive = activeC;
        this.ctrlData.action = action;
        this.utility.isBtnVisible = true;
        this.utility.isView = true;
        this.utility.actionStatus = actionStatus; // email template
        this.utility.btnAction = action;
        if (activeC == 3) {
          // 1 + 5
          this.router.navigate(["carrier/approval/correspondence"]);
        } else {
          // 0
          this.utility.isCarrierCancel = true;
          this.router.navigate(["account/approval"]);
        }
      }
    } else {
      // action = 3 (Escalate)
      // action = 4 (Update)
    }
  };

  showMenu(dropdown) {
    this.showMenuBtn = !this.showMenuBtn;
  }

  navigateUrl(path) {
    this.utility.isPermitCancel = true;
    this.router.navigateByUrl(path);
  }

  navigateUrlId(path, actionStatus: number, action: number) {
    // this.applicationService.getById(this.utility.permitAppId).subscribe(data => {
    //   this.permitService.UpdatePermitNum(this.utility.permitAppId).subscribe(data => {
    //   });
    // });
    //console.log(JSON.stringify(this.utility.permitAppId) + "=======================================================");
    //console.log(path + "=======================================================");

    if (this.canActivate(action)) {
      if (action == 2) {
        this.ctrlData.action = action;
        this.utility.btnAction = action;
        let statusId: any = this.utility.permitStatusId;
        let carrierStatusId = this.utility.carrierStatusId;

        if (statusId === 51) {
          this.toastService.error("Permit already approved!", "");
          return false;
        }
        if (carrierStatusId < 51) {
          this.toastService.error(
            "You may not approve the application as the carrier is not approved.",
            ""
          );
          return false;
        }
        if (carrierStatusId >= 91) {
          this.toastService.error(
            "You may not approve the application as the carrier is rejected or non-compliant.",
            ""
          );
          return false;
        }
        // if (statusId >= parseInt(this.permitStatus1) && statusId <= parseInt(this.permitStatus2)) {
        // if (statusId >= 41 && statusId <= 51) {

        if (statusId == this.permitStatus2 || statusId == 74) {
          this.isLoading = true;
          this.applicationService.getById(this.utility.permitAppId).subscribe(
            (app: any) => {
              if (app.vehicle.length != 0) {
                this.onApprovePermit();
              } else {
                this.toastService.error(
                  "A permit may not be approved without a vehicle.",
                  `Approval Denied`
                );
              }
              this.isLoading = false;
            },
            (error) => {
              this.isLoading = false;
            }
          );
        } else {
          this.toastService.error(
            `Only applications in "Submitted" status can be approved.`,
            `Approval Denied`
          );
        }
      } else {
        this.utility.actionStatus = actionStatus;
        this.ctrlData.action = action;
        this.utility.btnAction = action;
        this.router.navigate([path, this.utility.permitAppId]);
      }
    }
    //console.log('CarrierId = ', this.utility.carrierId);
    //console.log('Active = ', this.utility.currentActive);
  }

  canActivate = (action: number) => {
    return action == 0 || action == 1 || action == 2 || action == 5;
  };

  onApproveCarrier = () => {
    //console.log(this.utility);
    if (this.utility.carrierObject.data.status_id === 93) {
      return this.toastService.error("Account already rejected!", "");
    }

    if (this.utility.carrierObject.data.status_id === 999) {
      return this.toastService.error("Cannot approve inactive account!", "");
    }

    if (this.utility.carrierObject.data.status_id === 51) {
      return this.toastService.error("Account already approved!", "");
    }
    if (this.utility.carrierId > 0) {
      // this.msgService.showYesNo('Approve Carrier Account', `Are you sure you want to approve carrier account ${this.utility.carrierName}?`, 'An email will be sent to the applicant.').subscribe(isConfirmed => {
      //   if (isConfirmed) {
      //     this.message = 'Processing carrier account approval, please wait...';
      //     this.isLoading = true;
      //     this.carrierService.approveAccountAndSendNotification(this.utility.carrierId, this.username).subscribe((resp:any) => {
      //       if (resp.IsSent) {
      //         this.notice.success(`Carrier account ${this.utility.carrierName} approved and notification will be sent shortly.`, "Approve Carrier Account", { timeOut: 5000 });
      //         this.utility.isView = true;
      //         this.utility.currentActive = 1;
      //         this.router.navigate(['account/approval']);
      //       }
      //       else
      //         this.notice.info("A problem occured while processing your request. Please try again later.", "Approve Carrier Account", { timeOut: 5000 });
      //       this.isLoading = false;
      //     }, error => {
      //       this.isLoading = false;
      //     });
      //   }
      // })
      this.confirmDialogService.confirmThis(
        `Are you sure you want to approve carrier account ${this.utility.carrierName}? An email will be sent to the applicant.`,
        () => {
          this.message = "Processing carrier account approval, please wait...";
          this.isLoading = true;
          this.carrierService
            .approveAccountAndSendNotification(
              this.utility.carrierId,
              this.username
            )
            .subscribe(
              (resp: any) => {
                if (resp.IsSent) {
                  this.toastService.success(
                    `Carrier account ${this.utility.carrierName} approved and notification will be sent shortly.`,
                    "Approve Carrier Account"
                  );
                  this.utility.isView = true;
                  this.utility.currentActive = 1;
                  this.router.navigate(["account/approval"]);
                } else
                  this.toastService.error(
                    "A problem occured while processing your request. Please try again later.",
                    "Approve Carrier Account"
                  );
                this.isLoading = false;
              },
              (error) => {
                this.isLoading = false;
              }
            );
        },
        () => {
          //No here
        }
      );
    } else {
      this.toastService.error(
        "A problem occured while processing your request. Please try again later.",
        "Approve Carrier Account"
      );
    }
  };

  formatCurrency(value) {
    return accounting.formatMoney(value, "R", 2, " ", ".");
  }

  getUpdateBalance() {
    this.carrierService
      .getById(this.utility.carrierId)
      .subscribe((carr: any) => {
        if (carr != null && carr != undefined) {
          this.carrierService
            .getUpdateBalance(carr.carrier_account_id)
            .subscribe((res) => {});
        }
      });
  }

  setApplicationLock(application, lockStatus) {
    application.isLocked = lockStatus;
    application.isLockedBy = lockStatus
      ? this.authWebService.userData.User.UserName
      : "";

    this.applicationService.putApplication(application).subscribe(
      (r) => {
        if (lockStatus) {
          this.toastService.error(
            "Application Locked By '" + application.isLockedBy + "'",
            "Lock Application"
          );
        } else {
          this.toastService.error("Application Unlocked", "UnLock Application");
        }
      },
      (error) => {}
    );
  }

  onApprovePermit = () => {
    if (this.utility.carrierId > 0 && this.utility.permitAppId > 0) {
      let msg: any = "";
      if (this.utility.permitFreightId == 1) {
        msg = "Permit Approval";
      } else {
        msg = "Permit Approval";
      }

      // this.msgService.showYesNo(msg, `Are you sure you want to approve this permit?`, 'An email will be sent to the applicant.').subscribe(isConfirmed => {
      //   if (isConfirmed) {

      //     this.getUpdateBalance();

      //     this.message = 'Processing approval. Please wait...';
      //     this.isLoading = true;

      //     this.permitService.approvePermitAndSendNotification(this.utility.carrierId, this.utility.permitAppId, this.username).subscribe((resp:any) => {
      //       if (resp.IsSent && resp.InvoiceCreated) {
      //         //this.notice.success(`Permit approved and notification will be sent shortly.`, msg , { timeOut: 5000 });

      //         //Lock the application on approve
      //         this.applicationService.getApplicationByAppId(this.utility.permitAppId).subscribe(app=>{
      //           this.setApplicationLock(app, true);
      //         });
      //         this.msgService.showYesNo(msg, `Permit approved and notification will be sent shortly`, 'Would you like to Print this permit?').subscribe(isConfirmed => {
      //           this.utility.isView = true;
      //           this.getUpdateBalance();
      //           if (isConfirmed) {
      //            this.utility.isView = true;
      //             this.router.navigateByUrl('/permit/approval/printing/'+this.utility.permitAppId +'/true') ;
      //           }
      //           else
      //           {
      //             this.navigateUrl('/permit/approval');
      //           }
      //         });

      //         // this.utility.isView = true;
      //         // this.getUpdateBalance();

      //       }
      //       else if (!resp.IsSent)
      //       {
      //         if(resp.Message == 'InsufficientBalance')
      //         {
      //           this.notice.error("The Carrier has an insufficient balance in their account, you cannot proceed to approve this permit application.", msg, { timeOut: 5000 });
      //           //return;
      //         }
      //         else
      //         if(resp.Message == 'ZeroBalance')
      //         {
      //           this.notice.error("The Carrier has no Sufficient Funds in their Account, you cannot proceed to approve this permit application.", msg, { timeOut: 5000 });
      //           //return;
      //         }
      //         else
      //         {
      //           this.notice.error(resp.Message, msg, { timeOut: 5000 });
      //         }
      //       }
      //       else if(!resp.InvoiceCreated)
      //       {
      //         this.notice.error(resp.Message + '; \n Please notify administrator!', msg, { timeOut: 5000 });
      //       }
      //       else
      //         this.notice.info("A problem occured while processing your request. Please try again later." + resp.Message, msg, { timeOut: 5000 });
      //       this.isLoading = false;
      //     }, error => {
      //       this.isLoading = false;
      //     });
      //   }
      // })
      this.confirmDialogService.confirmThis(
        `Are you sure you want to approve this permit? An email will be sent to the applicant.`,
        () => {
          //check if otp is configured
          this.EnvokeOTP(msg);
        },
        () => {
          //No here
        }
      );
    } else {
      this.toastService.error(
        "A problem occured while processing your request. Please try again later.",
        "Temporary Permit Approval"
      );
    }
  };

  EnvokeOTP(msg) {
    if (this.permitMFA == "true") {
      let OtpMessage = document.getElementById("OtpMessage");
      this.isLoading = true;
      let userObj = Object.create(this.aUser);
      userObj.Id = this.aUser.Id;
      userObj.EmailAddress = this.aUser.EmailAddress;
      userObj.MobileNumber = this.aUser.MobileNumber;
      userObj.DialCodeMobile = this.aUser.DialCodeMobile;
      userObj.CommunicationType = this.aUser.CommunicationType;
      userObj.SysCode = "ICBMS";

      if (userObj.CommunicationType == "SMS") {
        OtpMessage.innerHTML =
          "We have sent the verification code to your mobile number.";
      } else {
        OtpMessage.innerHTML =
          "We have sent the verification code to your email address.";
      }

      this.authWebService
        .webrequest("POST", "UserService", "RequestOtp", userObj)
        .then(
          (data) => {
            if (data == true) {
              //show otp pop up
              document.getElementById("secretButton").click();
              this.isLoading = false;
            }
          },
          (error) => {}
        );
    } else {
      this.getUpdateBalance();

      this.message = "Processing approval. Please wait...";
      this.isLoading = true;

      this.permitService
        .approvePermitAndSendNotification(
          this.utility.carrierId,
          this.utility.permitAppId,
          this.username
        )
        .subscribe(
          (resp: any) => {
            if (resp.IsSent && resp.InvoiceCreated) {
              //this.notice.success(`Permit approved and notification will be sent shortly.`, msg , { timeOut: 5000 });

              //Lock the application on approve
              this.applicationService
                .getApplicationByAppId(this.utility.permitAppId)
                .subscribe((app) => {
                  this.setApplicationLock(app, true);
                });

              this.confirmDialogService.confirmThis(
                msg +
                  `Permit approved and notification will be sent shortly. Would you like to Print this permit?`,
                () => {
                  this.utility.isView = true;
                  this.getUpdateBalance();
                  this.utility.isView = true;
                  this.router.navigateByUrl(
                    "/permit/approval/printing/" +
                      this.utility.permitAppId +
                      "/true"
                  );
                },
                () => {
                  this.navigateUrl("/permit/approval");
                }
              );

              // this.utility.isView = true;
              // this.getUpdateBalance();
            } else if (!resp.IsSent) {
              if (resp.Message == "InsufficientBalance") {
                this.toastService.error(
                  "The Carrier has an insufficient balance in their account, you cannot proceed to approve this permit application.",
                  msg
                );
                //return;
              } else if (resp.Message == "ZeroBalance") {
                this.toastService.error(
                  "The Carrier has no Sufficient Funds in their Account, you cannot proceed to approve this permit application.",
                  msg
                );
                //return;
              } else {
                this.toastService.error(resp.Message, msg);
              }
            } else if (!resp.InvoiceCreated) {
              this.toastService.error(
                resp.Message + "; \n Please notify administrator!",
                msg
              );
            } else
              this.toastService.error(
                "A problem occured while processing your request. Please try again later." +
                  resp.Message,
                msg
              );
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }
  }

  verifyOtp() {
    const OtpCode = document.getElementById(
      "OTPCode"
    ) as HTMLInputElement | null;
    let Otp = OtpCode.value;

    this.aUser.Otp = Otp;

    if (this.utility.carrierId > 0 && this.utility.permitAppId > 0) {
      let msg: any = "";
      if (this.utility.permitFreightId == 1) {
        msg = "Permit Approval";
      } else {
        msg = "Permit Approval";
      }

      this.authWebService
        .webrequest(
          "POST",
          "UserService",
          "ValidateOtp",
          JSON.stringify(this.aUser)
        )
        .then(
          (ur) => {
            //if otp is valid, update the user details
            this.getUpdateBalance();

            this.message = "Processing approval. Please wait...";
            this.isLoading = true;

            this.permitService
              .approvePermitAndSendNotification(
                this.utility.carrierId,
                this.utility.permitAppId,
                this.username
              )
              .subscribe(
                (resp: any) => {
                  if (resp.IsSent && resp.InvoiceCreated) {
                    //this.notice.success(`Permit approved and notification will be sent shortly.`, msg , { timeOut: 5000 });

                    //Lock the application on approve
                    this.applicationService
                      .getApplicationByAppId(this.utility.permitAppId)
                      .subscribe((app) => {
                        this.setApplicationLock(app, true);
                      });
                    this.confirmDialogService.confirmThis(
                      msg +
                        `Permit approved and notification will be sent shortly. Would you like to Print this permit?`,
                      () => {
                        this.utility.isView = true;
                        this.getUpdateBalance();
                        this.utility.isView = true;
                        this.router.navigateByUrl(
                          "/permit/approval/printing/" +
                            this.utility.permitAppId +
                            "/true"
                        );
                      },
                      () => {
                        this.navigateUrl("/permit/approval");
                      }
                    );
                  } else if (!resp.IsSent) {
                    if (resp.Message == "InsufficientBalance") {
                      this.toastService.error(
                        "The Carrier has an insufficient balance in their account, you cannot proceed to approve this permit application.",
                        msg
                      );
                      //return;
                    } else if (resp.Message == "ZeroBalance") {
                      this.toastService.error(
                        "The Carrier has no Sufficient Funds in their Account, you cannot proceed to approve this permit application.",
                        msg
                      );
                      //return;
                    } else {
                      this.toastService.error(resp.Message, msg);
                    }
                  } else if (!resp.InvoiceCreated) {
                    this.toastService.error(
                      resp.Message + "; \n Please notify administrator!",
                      msg
                    );
                  } else
                    this.toastService.error(
                      "A problem occured while processing your request. Please try again later." +
                        resp.Message,
                      msg
                    );
                  this.isLoading = false;
                },
                (error) => {
                  this.isLoading = false;
                }
              );
          },
          (error) => {
            this.toastService.error("Invalid OTP", error.message);
          }
        );
    }
  }
}
